import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import NewsCard from "./NewsCard";
import { IRS_NEWS } from "../data/content";

const API = process.env.REACT_APP_BACKEND_URL;

export default function IrsNewsPreview() {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        let alive = true;
        axios
            .get(`${API}/api/news`, { timeout: 15000 })
            .then(({ data }) => {
                if (alive && data?.enabled) setArticles((data.articles || []).slice(0, 3));
            })
            .catch(() => {});
        return () => {
            alive = false;
        };
    }, []);

    if (!articles.length) return null;

    return (
        <section className="section-pad bg-[#F3F1EC] border-y border-[#E7E4DC]" data-testid="home-irs-news">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
                    <SectionHeading
                        eyebrow={IRS_NEWS.homeEyebrow}
                        title={<>IRS News &amp; <em className="italic text-[#8A6D2F]">Tax Updates.</em></>}
                        sub={IRS_NEWS.homeText}
                    />
                    <Reveal delay={0.1} className="shrink-0">
                        <Link
                            to="/irs-news"
                            data-testid="home-irs-news-viewall"
                            className="inline-flex items-center justify-center h-12 px-8 rounded-lg border border-[#D9D6CD] bg-white text-[13px] font-semibold uppercase tracking-[0.1em] text-[#3D434D] hover:border-[#C8A45D] hover:text-[#8A6D2F] transition-colors duration-300 whitespace-nowrap"
                        >
                            {IRS_NEWS.viewAll} <ArrowRight className="h-4 w-4" />
                        </Link>
                    </Reveal>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
                    {articles.map((a, i) => (
                        <Reveal key={a.id} delay={0.1 + i * 0.08} className="h-full">
                            <NewsCard article={a} index={i} />
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.1}>
                    <p className="text-[#737985] text-xs leading-relaxed mt-10 max-w-4xl">
                        Headlines, dates, and short summaries are published by the U.S. Internal Revenue Service and link
                        to the original articles on IRS.gov. Freedom Tax Filer is an independent tax-preparation business
                        and is not affiliated with or endorsed by the IRS — full notice on the IRS News page.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
